import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AnnouncementBar() {
  const [ann, setAnn] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    fetch(`${API}/announcement`)
      .then(r => r.json())
      .then(data => setAnn(data))
      .catch(() => {});
  }, []);

  if (!ann || !ann.enabled || dismissed) return null;

  return (
    <div className="w-full bg-rm-red text-white py-2.5 px-4 pr-10 flex items-center justify-center relative z-50" data-testid="announcement-bar">
      <div className="flex items-center justify-center gap-1 md:gap-2 text-xs md:text-sm font-medium text-center flex-wrap max-w-4xl">
        <span>{ann.text_before}</span>
        {ann.link_text && ann.link_url && (
          <a href={ann.link_url} target="_blank" rel="noopener noreferrer"
            className="text-blue-200 hover:text-white underline font-bold transition-colors whitespace-nowrap" data-testid="announcement-link">
            {ann.link_text}
          </a>
        )}
        {ann.text_after && <span>{ann.text_after}</span>}
      </div>
      <button onClick={() => setDismissed(true)}
        className="absolute right-2 md:right-3 top-1/2 -translate-y-1/2 p-1.5 hover:bg-white/10 rounded transition-all"
        data-testid="announcement-dismiss"
        aria-label="Dismiss announcement">
        <X size={16} className="md:w-4 md:h-4" />
      </button>
    </div>
  );
}
